export enum UserTypesCodes {
  Common = "common",
  Technique = "technique",
  Admin = "admin",
  Terrain = "terrain",
  Fournisseur = "fournisseur",
  Eleveur = "eleveur",
}

export enum UserTypes {
  PARTICULIER = "PARTICULIER",
  ENTREPRISE = "ENTREPRISE",
  ADMINISTRATEUR = "ADMINISTRATEUR",
  VETERINAIRE = "VETERINAIRE",
  TECHNIQUE = "TECHNIQUE",
  TERRAIN = "TERRAIN",
  OFFICIER = "OFFICIER",
  FOURNISSEUR = "FOURNISSEUR",
  SANITAIRE = "SANITAIRE",
  AUTRE = "AUTRE",
}
